var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2779 13.8891C17.9526 13.8891 18.519 14.446 18.4158 15.1123C17.8105 19.0323 14.4547 21.9428 10.4074 21.9428C5.92948 21.9428 2.3 18.3134 2.3 13.8365C2.3 10.1481 5.10211 6.7123 8.25684 5.93546C8.93474 5.76809 9.62948 6.24493 9.62948 6.94283C9.62948 11.6712 9.78842 12.8944 10.6863 13.5597C11.5842 14.2249 12.64 13.8891 17.2779 13.8891Z",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6925 9.9517C21.7462 6.9138 18.0146 2.01696 13.4673 2.10117C13.1136 2.10749 12.8304 2.40222 12.8146 2.75485C12.6999 5.25275 12.8546 8.48959 12.9409 9.95696C12.9673 10.4138 13.3262 10.7727 13.782 10.7991C15.2904 10.8854 18.6452 11.0033 21.1073 10.6306C21.442 10.5801 21.6873 10.2896 21.6925 9.9517Z",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.ccf5089d858edb35e98757e871a9aec3.svg";
export { ForwardRef as ReactComponent };